import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45jwt_45global from "/app/middleware/00.jwt.global.ts";
import _01_45site_45global from "/app/middleware/01.site.global.ts";
import _02_45auth_45global from "/app/middleware/02.auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45jwt_45global,
  _01_45site_45global,
  _02_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}